// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__1vzKJ"};